import ProjectFormsController from "../add-project";

const EditProjectDashboard = () => {
    return <ProjectFormsController/>
}

export default EditProjectDashboard;